import { render, staticRenderFns } from "./show.vue?vue&type=template&id=60e84df4&scoped=true&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"
import style0 from "./show.vue?vue&type=style&index=0&id=60e84df4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e84df4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60e84df4')) {
      api.createRecord('60e84df4', component.options)
    } else {
      api.reload('60e84df4', component.options)
    }
    module.hot.accept("./show.vue?vue&type=template&id=60e84df4&scoped=true&", function () {
      api.rerender('60e84df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/settlement/show.vue"
export default component.exports